export const SPACES = [
  '원룸',
  '거실',
  '침실',
  '주방',
  '욕실',
  '아이방',
  '드레스룸',
  '서재&작업실',
  '베란다',
  '사무공간',
  '가구&소품',
  '현관',
  '외관&기타',
];

export const TOAST = {
  position: 'bottom-center',
  autoClose: 2500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
};

export const MOUSEBENCHMARK = {
  xLeftBenchmark: 6,
  xRightBenchmark: 94,
  yLeftBenchmark: 5,
  yRightBenchmark: 95,
};

export const BUBBLEBENCHMARK = {
  leftBenchmark: 33,
  rightBenchmark: 67,
  leftDefaultValue: 6,
  rightDefaultValue: 51.5,
  leftWeighting: 1.59,
  rightWeighting: 1.63,
  yPositionBenchmark: 28,
};
